import { render } from "./CharacterRoles.vue?vue&type=template&id=0931429e"
import script from "./CharacterRoles.vue?vue&type=script&lang=js"
export * from "./CharacterRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__